export class User {
    firstName: string;
    lastName: string;
    displayName: string;
    fullName: string;
    email: string;
    issuperuser: boolean;
    permissions: any;
    scope: any;
    avatar: string;
    id: number;
    idClient: number;
    userId: number;
    userName: string;
    name: string;
    phone: string;
    idProvince: number;
    idDistrict: number;
    idWard: number;
    address: string;
    isDeleted: boolean;
}
